import React from 'react';
import LegalDoc from './LegalDoc';
import content from './AI_DISCLOSURE.md?raw';

const AiDisclosure = () => <LegalDoc content={content} />;

export default AiDisclosure;
